export enum stateCodeEnum {
  AVAILABLE = 'AVAILABLE',
  CONFIRM = 'CONFIRM',
  UNEFFECTIVE = 'UNEFFECTIVE',

  USED = 'USED',
  OVERDUE = 'OVERDUE',
  UNAVAILABLE = 'UNAVAILABLE',
}

export enum stateCodeEnumName {
  AVAILABLE = '去使用', // 可使用，跳转提现页
  CONFIRM = '去使用', // 待确认，跳转授信页
  UNEFFECTIVE = '待生效', // 待生效

  USED = '已使用', // 已使用
  OVERDUE = '已过期', // 已过期
  UNAVAILABLE = '不可用', // 不可用
}


export enum rejectRuleType {
  /** 渠道限制规则 */
  LOAN_CHANNEL_GROUP_RULE = 'LoanChannelGroupRule',
  /** 满额限制规则 */
  FULL_LOAN_AMOUNT_RULE = 'FullLoanAmountRule',
  /** 额度限制规则 */
  MIN_LOAN_AMOUNT_RULE = 'MinLoanAmountRule',
  /** 客群规则--暂不包含当前场景 */
  CUSTOM_GROUP_RULE = 'CustomerGroupRule',
}

export enum UseSceneEnum {
  /** 借款 */
  LEND = 'LEND',
  /** 还款 */
  REPAY = 'REPAY',
}

/** 我的优惠券列表入参 */
export interface CouponVo {
  pageIndex: number;
  pageSize: number;
}

/** 规则优惠券入参 */
export interface CouponRoleVo extends CouponVo {
  productId: string;
  loanAmount: number;
  /** 最大提现金额 */
  maxAmount: number;
  selCurrentPeriod: number;
  repayType?: string;
  /** capitalCode 资方code */
  capitalCode?: string;
  repayOnSchedule?: boolean;
}

/** 我的优惠券列表出参 */
export interface CouponPo {
  amount: string;
  // 折扣券 最大优惠金额
  amountBig: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  couponId: string;
  couponName: string;
  isExtend?: boolean;
  comments: string;
  isSelected?: boolean | string;
  couponType?: string; // 优惠券类型
  stateCode: stateCodeEnum;
  /** 跳转可用产品 */
  availableProductId?: string;
  /** 不可用规则 */
  rejectRule?: rejectRuleType;
  /** 不可用规则描述 */
  rejectRuleDesc?: string;
  /** 渠道优惠券 id */
  externalCouponId?: string;
  /** 使用场景 */
  useScene: UseSceneEnum;
}

/** 规则优惠券出参 */
export interface CouponRolePo extends CouponPo {
  isFirst: boolean;
  availability: boolean;
  usageAmount?: number;
  /** 优惠券批次号 */
  couponBatch: string;
  /** 优惠券类型 */
  freeCouponType?: CouponTypeEnum;
  /** 规则信息 */
  ruleInfo?: {
    /** 需要满额提现 */
    fullLoanAmount?: boolean;
  };
}

/** 我的优惠券列表 是否可用参数 */
export enum CouponStateTypeEnum {
  /** 可用优惠券 */
  USEFUL = 'USEFUL',
  /** 逾期优惠券 */
  EXPIRE = 'EXPIRED',
}

/** 优惠券类型 */
export enum CouponTypeEnum {
  /** 普通金额券 */
  NORMAL = 'NORMAL',
  /** 免息券 */
  PERIOD = 'PERIOD',
  /** 折扣免息券 */
  DISCOUNT = 'DISCOUNT',
  /** 利率免息券 */
  INTEREST = 'INTEREST',
  /** X天Y元免息券 */
  X_DAYS_Y_AMOUNT = 'X_DAYS_Y_AMOUNT',
  /** X元Y期免息券 */
  X_AMOUNT_Y_PERIOD = 'X_AMOUNT_Y_PERIOD',
  /** 哈啰零用钱免息券 */
  HELLO_PETTY_CASH_INTEREST_FREE = 'HELLO_PETTY_CASH_INTEREST_FREE',
}
